import { render } from "./Automotive.vue?vue&type=template&id=79dd0ed0"
import script from "./Automotive.vue?vue&type=script&lang=js"
export * from "./Automotive.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__